/**
 * Parses the OTP input value
 * @param {typeof import('./constants').DEFAULT_OTP_INPUT_FIELD_VALUE} value
 * @returns {string}
 */
export const parseOTPInputValue = (value) => value.map((code) => code.value).join('');
